export const HANDLE_PLANS = "HANDLE_PLANS";

interface HandlePlansAction {
	type: typeof HANDLE_PLANS
	payload: any
}

export type plansActionTypes = HandlePlansAction
